"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _joiBrowser = _interopRequireDefault(require("joi-browser"));

var _HttpService = _interopRequireDefault(require("../HttpService"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var EventService = /*#__PURE__*/function () {
  function EventService() {
    _classCallCheck(this, EventService);
  }

  _createClass(EventService, null, [{
    key: "isAddEventRequestValid",
    value: function isAddEventRequestValid(addEventRequest) {
      if (addEventRequest === null || addEventRequest === undefined) {
        return false;
      }

      var schema = _joiBrowser["default"].object().keys({
        name: _joiBrowser["default"].string().min(2).max(50).required(),
        description: _joiBrowser["default"].string().min(0).max(1024).allow(''),
        startingStatusComment: _joiBrowser["default"].string().min(0).max(1024).allow(''),
        startingStatusId: _joiBrowser["default"].number().integer().allow(null),
        tags: _joiBrowser["default"].array().items(_joiBrowser["default"].number().integer()).required().required(),
        eventData: _joiBrowser["default"].object().allow(null),
        dueDate: _joiBrowser["default"].date().allow(null),
        assignment: _joiBrowser["default"].string().allow(null).allow('')
      });

      return _joiBrowser["default"].validate(addEventRequest, schema).error === null;
    }
  }, {
    key: "searchEvents",
    value: function searchEvents(searchEventsRequest, page, size, sortStartDateDesc, updatedAfter) {
      var _this = this;

      if (!searchEventsRequest) {
        return Promise.reject(new Error('We\'re having issues loading new events. Please try again later.'));
      }

      var modifiedRequest = searchEventsRequest;

      if (sortStartDateDesc !== undefined) {
        modifiedRequest.sortStartDateDesc = sortStartDateDesc;
      }

      var updatedAfterQueryParam = '';

      if (updatedAfter) {
        updatedAfterQueryParam = "&updatedAfter=".concat(updatedAfter);
      }

      return new Promise(function (resolve, reject) {
        _this.httpService.post("/search?page=".concat(page, "&size=").concat(size).concat(updatedAfterQueryParam), modifiedRequest).then(function (response) {
          resolve(response);
        }, function (error) {
          return reject(new Error(error.data.message));
        });
      });
    }
  }, {
    key: "getActivity",
    value: function getActivity(auth0UserId, page, size) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        _this2.httpService.get("/activity?page=".concat(page, "&size=").concat(size, "&auth0UserId=").concat(auth0UserId)).then(function (response) {
          resolve(response);
        }, function (error) {
          return reject(new Error(error.data.message));
        });
      });
    }
  }, {
    key: "getAnalytics",
    value: function getAnalytics(searchEventsRequest) {
      var _this3 = this;

      if (!searchEventsRequest) {
        return Promise.reject(new Error('We\'re having issues loading event analytics. Please try again later.'));
      }

      return new Promise(function (resolve, reject) {
        _this3.httpService.post('/analytics', searchEventsRequest).then(function (response) {
          resolve(response);
        }, function (error) {
          return reject(new Error(error.data.message));
        });
      });
    }
  }, {
    key: "addEvent",
    value: function addEvent(addEventRequest) {
      var _this4 = this;

      if (!EventService.isAddEventRequestValid(addEventRequest)) {
        return Promise.reject(new Error('Invalid create event request'));
      }

      return new Promise(function (resolve, reject) {
        _this4.httpService.post('/', addEventRequest).then(function (response) {
          resolve(response);
        }, function (error) {
          return reject(new Error(error.data.message));
        });
      });
    }
  }, {
    key: "getEvent",
    value: function getEvent(id) {
      return this.httpService.get("/".concat(id));
    }
  }, {
    key: "patchEvent",
    value: function patchEvent(id, _ref) {
      var _ref$archived = _ref.archived,
          archived = _ref$archived === void 0 ? false : _ref$archived,
          _ref$completeEvent = _ref.completeEvent,
          completeEvent = _ref$completeEvent === void 0 ? null : _ref$completeEvent,
          _ref$description = _ref.description,
          description = _ref$description === void 0 ? null : _ref$description,
          _ref$eventData = _ref.eventData,
          eventData = _ref$eventData === void 0 ? null : _ref$eventData,
          _ref$name = _ref.name,
          name = _ref$name === void 0 ? null : _ref$name,
          _ref$tags = _ref.tags,
          tags = _ref$tags === void 0 ? null : _ref$tags,
          _ref$dueDate = _ref.dueDate,
          dueDate = _ref$dueDate === void 0 ? null : _ref$dueDate;
      return this.httpService.patch("/".concat(id), {
        archived: archived,
        completeEvent: completeEvent,
        description: description,
        eventData: eventData,
        name: name,
        tags: tags,
        dueDate: dueDate
      });
    }
  }, {
    key: "addComment",
    value: function addComment(id, _ref2) {
      var comment = _ref2.comment,
          _ref2$commentHeader = _ref2.commentHeader,
          commentHeader = _ref2$commentHeader === void 0 ? 'General Discussion' : _ref2$commentHeader,
          parentCommentId = _ref2.parentCommentId;
      return this.httpService.post("/".concat(id, "/comments"), {
        comment: comment,
        commentHeader: commentHeader,
        parentCommentId: parentCommentId
      });
    }
  }, {
    key: "addUpload",
    value: function addUpload(id) {
      var displayName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Event Upload';
      var file = arguments.length > 2 ? arguments[2] : undefined;
      return this.httpService.postFile("/".concat(id, "/eventUploads?displayName=").concat(displayName), file);
    }
  }, {
    key: "changeStatus",
    value: function changeStatus(id, _ref3) {
      var statusId = _ref3.statusId,
          _ref3$statusComment = _ref3.statusComment,
          statusComment = _ref3$statusComment === void 0 ? null : _ref3$statusComment,
          _ref3$completeEvent = _ref3.completeEvent,
          completeEvent = _ref3$completeEvent === void 0 ? false : _ref3$completeEvent,
          _ref3$assignment = _ref3.assignment,
          assignment = _ref3$assignment === void 0 ? '' : _ref3$assignment;
      return this.httpService.post("/".concat(id, "/eventStatus"), {
        statusId: statusId,
        statusComment: statusComment,
        completeEvent: completeEvent,
        assignment: assignment
      });
    }
  }, {
    key: "getExport",
    value: function getExport(request) {
      return this.httpService.getFileDownloadWithPost('/export', request);
    }
  }]);

  return EventService;
}();

exports["default"] = EventService;
EventService.httpService = new _HttpService["default"]({
  baseURL: "".concat(typeof window !== 'undefined' ? env.REACT_APP_EVENT_API : '', "/events")
});